import { render } from "./bodyBgArea.vue?vue&type=template&id=307027b5&lang=true"
import script from "./bodyBgArea.vue?vue&type=script&lang=js"
export * from "./bodyBgArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__